import { render, staticRenderFns } from "./ReportType.vue?vue&type=template&id=5525bd0a"
import script from "./ReportType.vue?vue&type=script&lang=js"
export * from "./ReportType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports